import { Button } from '@/components/ui/Button';
import { useToggleUserLock, useResetUserPassword, useImpersonateUser, useDeleteUser } from '@/hooks/useAdminUsers';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { Lock, Unlock, KeyRound, UserCog, Trash2 } from 'lucide-react';
import { useState } from 'react';

interface UserActionsMenuProps {
  userUuid: string;
  isLocked: boolean;
}

export function UserActionsMenu({ userUuid, isLocked }: UserActionsMenuProps) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const toggleLock = useToggleUserLock();
  const resetPassword = useResetUserPassword();
  const impersonate = useImpersonateUser();
  const deleteUser = useDeleteUser();

  return (
    <div className="flex flex-wrap gap-2">
      <Button
        variant="outline"
        size="sm"
        icon={isLocked ? <Unlock className="h-3.5 w-3.5" /> : <Lock className="h-3.5 w-3.5" />}
        onClick={() => toggleLock.mutate(userUuid)}
        loading={toggleLock.isPending}
      >
        {isLocked ? 'Débloquer' : 'Bloquer'}
      </Button>
      <Button
        variant="outline"
        size="sm"
        icon={<KeyRound className="h-3.5 w-3.5" />}
        onClick={() => resetPassword.mutate(userUuid)}
        loading={resetPassword.isPending}
      >
        Reset MDP
      </Button>
      <Button
        variant="outline"
        size="sm"
        icon={<UserCog className="h-3.5 w-3.5" />}
        onClick={() => impersonate.mutate(userUuid)}
        loading={impersonate.isPending}
      >
        Impersonner
      </Button>
      <Button
        variant="danger"
        size="sm"
        icon={<Trash2 className="h-3.5 w-3.5" />}
        onClick={() => setConfirmDelete(true)}
      >
        Supprimer
      </Button>
      <ConfirmDialog
        isOpen={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        onConfirm={() => deleteUser.mutate(userUuid)}
        title="Supprimer l'utilisateur"
        message="Cette action est irréversible. Toutes les données associées seront supprimées."
        confirmLabel="Supprimer"
        loading={deleteUser.isPending}
      />
    </div>
  );
}
